import type { Dayjs } from 'dayjs';
import type { Kpi } from 'lumen/utils/constants/ri-constant-values';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function generateRevenueInsightRedirectUrlQueryParams(
  kpi: Kpi,
  startDateMoment: Dayjs,
  endDateMoment: Dayjs,
) {
  const fromDate = startDateMoment.format('YYYY-MM-DD');
  const toDate = endDateMoment.format('YYYY-MM-DD');

  return {
    kpi,
    fromDate,
    toDate,
  };
}
